'use client';
import { DropdownMenuItem, toast } from '@baseball-near-you/ui';
import { QueryKey } from '@bb/lib/hooks/QueryKey';
import { createClient } from '@bb/lib/supabase/client';
import { useQueryClient } from '@tanstack/react-query';
import { UserCheck2Icon } from 'lucide-react';
import posthog from 'posthog-js';

export function SignOutDropdownMenuItem() {
  const queryClient = useQueryClient();
  const { auth } = createClient();

  return (
    <DropdownMenuItem
      className="title md:!pt-1.5 py-3 text-lg md:py-0.5 md:text-lg"
      onClick={async () => {
        const { error } = await auth.signOut();
        await queryClient.refetchQueries([QueryKey.User]);

        if (error) {
          toast.error('There was an error signing out.', {
            description: error.message,
            icon: <UserCheck2Icon className="text-red-700" />,
          });
        } else {
          posthog.reset();
          toast.success('You have been signed out.', {
            icon: <UserCheck2Icon className="text-green-700" />,
          });
        }
      }}
    >
      SIGN OUT
    </DropdownMenuItem>
  );
}
